

@if (FG) {
  <div [formGroup]="FG" class="flex align-items-center column-gap-2">
    <div style="width: 13ch">
      <p-calendar
        #startCalendar
        [showTime]="false"
        [showIcon]="false"
        formControlName="startAt"
        [dateFormat]="'primeng.dateFormat' | translate"
        inputId="startAt"
        appendTo="body"
        [baseZIndex]="9999999999"
        styleClass="w-full">
      </p-calendar>
    </div>
    
    <div style="width: 8ch;">
      <app-time-input (click)="onTimeInput($event, startAtWhisper)" [FC]="FG.controls.startAtTime" />
      <div class="relative">
        <p-menu #startAtWhisper [model]="whisperValueMenuItems" [autofocus]="false" [popup]="true" class="time-whisper-menu"></p-menu>
      </div>
    </div>
  
    <div class="flex align-items-center">
      <span>
        -
      </span>
    </div>
    
    <div style="width: 8ch;">
      <app-time-input (click)="onTimeInput($event, endAtWhisper)" [FC]="FG.controls.endAtTime" />
      <div class="relative">
        <p-menu #endAtWhisper [model]="whisperValueMenuItems" [autofocus]="false" [popup]="true" class="time-whisper-menu"></p-menu>
      </div>
    </div>
  
    <div style="width: 13ch;">
      <p-calendar
        #endCalendar
        [showTime]="false"
        [showIcon]="false"
        formControlName="endAt"
        [dateFormat]="'primeng.dateFormat' | translate"
        inputId="endAt"
        appendTo="body"
        [baseZIndex]="9999999999"
        styleClass="w-full">
      </p-calendar>
    </div>
  
  </div>
}